import React from 'react';
import { connect } from 'react-redux';
import { Section, Title, Modal } from '@common/components';
import { popIn } from '@common/utils/services';
import OrderForm from '../Form';
import { createStock } from '@resources/Stock/actions';
import { useIntl } from 'react-intl';

const Create = (props) => {
	const { createStock, visible, onCancel } = props;
	const intl = useIntl();

	const handleSubmit = (data) => {
		return createStock(data)
			.then((response) => {
				popIn(
					'success',
					intl.formatMessage({
						id: 'message.success.department.create',
						defaultMessage:
							'A new Order has been successfully created',
					})
				);

				onCancel && onCancel();
			})
			.catch((err) => Promise.reject(err));
	};

	return (
		<Modal visible={visible} onCancel={() => onCancel && onCancel()}>
			<Title>
				{intl.formatMessage({
					id: 'common.new.department',
					defaultMessage: 'Create Order',
				})}
			</Title>
			<Section className="mb-5">
				<OrderForm onSubmit={handleSubmit} {...props} />
			</Section>
		</Modal>
	);
};

const mapStateToProps = ({
	items,
	modules,
	cellGroup,
	event,
	facility,
	ministry,
	mission,
	organization,
	prayer,
	testimony,
	service,
}) => {
	return {
		items,
		modules,
		cellGroup,
		event,
		facility,
		ministry,
		mission,
		organization,
		prayer,
		testimony,
		service,
	};
};

export default connect(mapStateToProps, {
	createStock,
})(Create);
